import React from 'react';

const WhyItWorks: React.FC = () => {
  const systems = [
    {
      icon: 'ri-focus-3-line',
      name: 'Expectation Modeling',
      description: 'Maps what users expect vs. what your app delivers'
    },
    {
      icon: 'ri-brain-line',
      name: 'Cognitive Load Simulation',
      description: 'Measures mental effort required to use your app'
    },
    {
      icon: 'ri-alert-line',
      name: 'Friction Point Indicators',
      description: 'Identifies where users get stuck or confused'
    },
    {
      icon: 'ri-heart-pulse-line',
      name: 'Emotional Flow Resonance',
      description: 'Tracks emotional response throughout the experience'
    },
    {
      icon: 'ri-fire-line',
      name: 'Desire Trigger Scoring',
      description: 'Evaluates how well your app creates user motivation'
    },
    {
      icon: 'ri-bar-chart-box-line',
      name: 'Category Standards Benchmarking',
      description: 'Compares your app against top performers in your space'
    },
    {
      icon: 'ri-message-3-line',
      name: 'Narrative & Value Alignment',
      description: 'Ensures your messaging matches user perception'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Why CrowdRounds Works
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our intelligence platform combines 7 proprietary systems to give you clarity no other tool can provide.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {systems.map((system, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl border-2 border-gray-200 hover:border-teal-500 transition-all duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-teal-50 text-teal-600 rounded-lg mb-4 group-hover:bg-teal-500 group-hover:text-white transition-colors">
                <i className={`${system.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">
                {system.name}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {system.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 max-w-4xl mx-auto">
            Powered by structured intelligence, benchmarks, and analysis systems designed to remove founder bias and deliver objective clarity.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyItWorks;
